import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { errorMessage } from "../redux/errorState";
import { setNetworkState } from "../redux/network";

export default function useNetwork() {
  
  const dispatch = useDispatch();
  const network = useSelector((state) => state.network);

  useEffect(() => {
    const bodyEvent = (e) => {
      if (!network.networkState) {
        e.stopImmediatePropagation()
        dispatch(errorMessage("NETWORK_ERROR"))
      }
    }
    if (!network.networkState) {
      document.getElementById("app_main").addEventListener('click', bodyEvent, true); 
      document.getElementById("app_main").addEventListener('touchstart', bodyEvent, true); 
      
    }
    
    return () => {
      document.getElementById("app_main").removeEventListener('click', bodyEvent, true); 
      document.getElementById("app_main").removeEventListener('touchstart', bodyEvent, true); 
    }
  }, [network.networkState]);


  const networkCheck = useCallback(() => {
    window.addEventListener('online', (e) => {
      console.log("online");
      dispatch(setNetworkState({ networkState: true }));
    });
    window.addEventListener('offline', (e) => {
      console.log("offline");
      dispatch(setNetworkState({ networkState: false }));
    });
  }, []);

  return {
    networkCheck
  }

}